/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Country_Count_SingleInputs */

const bn_country_count_single = /** @type {(inputs: Country_Count_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} দেশ`)
};

const de_country_count_single = /** @type {(inputs: Country_Count_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Land`)
};

const el_country_count_single = /** @type {(inputs: Country_Count_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} χώρα`)
};

const en_country_count_single = /** @type {(inputs: Country_Count_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} country`)
};

const es_country_count_single = /** @type {(inputs: Country_Count_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} país`)
};

const fr_country_count_single = /** @type {(inputs: Country_Count_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} pays`)
};

const hi_country_count_single = /** @type {(inputs: Country_Count_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} देश`)
};

const hu_country_count_single = /** @type {(inputs: Country_Count_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ország`)
};

const id_country_count_single = /** @type {(inputs: Country_Count_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} negara`)
};

const it_country_count_single = /** @type {(inputs: Country_Count_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Paese`)
};

const ja_country_count_single = /** @type {(inputs: Country_Count_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 国`)
};

const ko_country_count_single = /** @type {(inputs: Country_Count_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 국가`)
};

const nl_country_count_single = /** @type {(inputs: Country_Count_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} land`)
};

const pl_country_count_single = /** @type {(inputs: Country_Count_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} kraj`)
};

const pt_country_count_single = /** @type {(inputs: Country_Count_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} país`)
};

const ru_country_count_single = /** @type {(inputs: Country_Count_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} страна`)
};

const sv_country_count_single = /** @type {(inputs: Country_Count_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} land`)
};

const tr_country_count_single = /** @type {(inputs: Country_Count_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ülke`)
};

const uk_country_count_single = /** @type {(inputs: Country_Count_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} країна`)
};

const vi_country_count_single = /** @type {(inputs: Country_Count_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} quốc gia`)
};

const zh_country_count_single = /** @type {(inputs: Country_Count_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 国家`)
};

const zh_hant_country_count_single = /** @type {(inputs: Country_Count_SingleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 國家`)
};

/**
* | output |
* | --- |
* | "{count} country" |
*
* @param {Country_Count_SingleInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const country_count_single = /** @type {((inputs: Country_Count_SingleInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Country_Count_SingleInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_country_count_single(inputs)
	if (locale === "de") return de_country_count_single(inputs)
	if (locale === "el") return el_country_count_single(inputs)
	if (locale === "en") return en_country_count_single(inputs)
	if (locale === "es") return es_country_count_single(inputs)
	if (locale === "fr") return fr_country_count_single(inputs)
	if (locale === "hi") return hi_country_count_single(inputs)
	if (locale === "hu") return hu_country_count_single(inputs)
	if (locale === "id") return id_country_count_single(inputs)
	if (locale === "it") return it_country_count_single(inputs)
	if (locale === "ja") return ja_country_count_single(inputs)
	if (locale === "ko") return ko_country_count_single(inputs)
	if (locale === "nl") return nl_country_count_single(inputs)
	if (locale === "pl") return pl_country_count_single(inputs)
	if (locale === "pt") return pt_country_count_single(inputs)
	if (locale === "ru") return ru_country_count_single(inputs)
	if (locale === "sv") return sv_country_count_single(inputs)
	if (locale === "tr") return tr_country_count_single(inputs)
	if (locale === "uk") return uk_country_count_single(inputs)
	if (locale === "vi") return vi_country_count_single(inputs)
	if (locale === "zh") return zh_country_count_single(inputs)
	return zh_hant_country_count_single(inputs)
});